import React from "react";

import { ReactComponent as HushEventsSVG } from "src/images/svg/hush-events.svg";

import "./hush-events.css";

export const HushEvents = ({ className }: { className?: string }) => {
	return <HushEventsSVG className={className} />;
};
